import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { TabChild } from '../types/ui_types';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (<Box sx={{ p: 3 }} children={<Typography component='span' children={children}/>}/>)}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


interface BasicTabsProps {
    children: TabChild[];
}
  

export default function BasicTabs(props: BasicTabsProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs" variant="scrollable" allowScrollButtonsMobile >
        { props.children.map((child: TabChild, index: number)=><Tab label={child.label} key={index*10} {...a11yProps(index)} />) }
        </Tabs>
      </Box>
      { props.children.map((child: TabChild, index: number)=><TabPanel value={value} key={index} index={index} children={child.content} />) }
    </Box>
  );
}
